import { Form, Select, InputNumber, DatePicker, Checkbox, Row, Col } from "antd";
import dayjs from "dayjs";

const FREQUENCY_OPTIONS = [
  { value: "DAILY", label: "Diaria" },
  { value: "WEEKLY", label: "Semanal" },
  { value: "MONTHLY", label: "Mensual" },
  { value: "CUSTOM_DAYS", label: "Cada X dias" },
  { value: "SPECIFIC_DAYS", label: "Dias especificos" },
];

const WEEKDAY_OPTIONS = [
  { value: 0, label: "Lunes" },
  { value: 1, label: "Martes" },
  { value: 2, label: "Miercoles" },
  { value: 3, label: "Jueves" },
  { value: 4, label: "Viernes" },
  { value: 5, label: "Sabado" },
  { value: 6, label: "Domingo" },
];

function RecurringTaskConfig({ form, startDate }) {
  const frequency = Form.useWatch("frequency", form);

  return (
    <div className="border rounded-lg p-4 bg-gray-50 space-y-4">
      <div className="text-sm font-medium text-gray-700 mb-2">
        Configuracion de repeticion
      </div>

      <Form.Item
        name="frequency"
        label="Frecuencia"
        rules={[{ required: true, message: "Selecciona una frecuencia" }]}
      >
        <Select options={FREQUENCY_OPTIONS} placeholder="Selecciona frecuencia" />
      </Form.Item>

      {frequency === "CUSTOM_DAYS" && (
        <Form.Item
          name="interval"
          label="Repetir cada"
          rules={[{ required: true, message: "Ingresa el intervalo" }]}
        >
          <InputNumber
            min={1}
            max={365}
            addonAfter="dias"
            style={{ width: "100%" }}
          />
        </Form.Item>
      )}

      {frequency === "SPECIFIC_DAYS" && (
        <Form.Item
          name="weekdays"
          label="Dias de la semana"
          rules={[{ required: true, message: "Selecciona al menos un dia" }]}
        >
          <Checkbox.Group style={{ width: "100%" }}>
            <Row>
              {WEEKDAY_OPTIONS.map((day) => (
                <Col span={8} key={day.value}>
                  <Checkbox value={day.value}>{day.label}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      )}

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="startDate"
            label="Fecha inicio"
            rules={[{ required: true, message: "Selecciona fecha de inicio" }]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              disabledDate={(current) =>
                current && current < dayjs().startOf("day")
              }
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="endDate"
            label="Fecha fin"
            rules={[
              { required: true, message: "Selecciona fecha de fin" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || !getFieldValue("startDate")) {
                    return Promise.resolve();
                  }
                  if (value.isBefore(getFieldValue("startDate"))) {
                    return Promise.reject(
                      new Error("La fecha fin debe ser posterior al inicio")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              disabledDate={(current) => {
                const start = form.getFieldValue("startDate");
                if (!start) return current && current < dayjs().startOf("day");
                return current && current < start;
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <div className="text-xs text-gray-500">
        Al crear esta tarea periodica, se generaran automaticamente todas las
        instancias hasta la fecha de fin.
      </div>
    </div>
  );
}

export default RecurringTaskConfig;
